export function getCommonStyles() {
    const mainBtnStyle = { width: '190px', margin: '5px', boxShadow: '0px 1px 3px #999', fontWeight: '600', pl: '0px', pr: '0px', backgroundColor: 'rgba(25, 118, 210, 0.08)' };
    const simpleBtnStyle = { margin: '5px', boxShadow: '0px 1px 3px #999', fontWeight: '600', backgroundColor: 'rgba(25, 118, 210, 0.08)' };

    return { mainBtnStyle, simpleBtnStyle };
}
